import { Reveal } from "@/components/Reveal";
import { UserX, Trash2 } from "lucide-react";

const CONTROLS = [
  { label: "Delete My Account", href: "/delete-account.html", icon: UserX, desc: "Permanently remove your account and all associated data.", testid: "delete-account-btn" },
  { label: "Delete My Data", href: "/delete-data.html", icon: Trash2, desc: "Remove specific data without deleting your whole account.", testid: "delete-data-btn" },
];

export default function AccountControls() {
  return (
    <section id="account" className="relative scroll-mt-24 pb-4" data-testid="account-controls">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <p className="eyebrow">Account & Data Controls</p>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl">
            You're always in control
          </h2>
          <p className="mt-4 max-w-2xl text-muted-foreground">
            Manage your account and data at any time. These controls are always available to every user.
          </p>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {CONTROLS.map((c) => (
            <a
              key={c.href}
              href={c.href}
              data-testid={c.testid}
              className="group flex items-start gap-4 rounded-2xl border border-border bg-card/40 p-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-destructive/50"
            >
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-destructive/30 bg-destructive/10 text-destructive">
                <c.icon className="h-5 w-5" />
              </span>
              <span className="flex flex-col">
                <span className="font-display font-semibold text-foreground group-hover:text-destructive">{c.label}</span>
                <span className="mt-1 text-sm text-muted-foreground">{c.desc}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
